<template>
  <div id="CompanyApproval">
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_CompanyApproval')" />
    <div class="container-fluid">
      <div class="card card-radius">
        <!-- Toolbar: Batch Action + Search -->
        <div class="toolbar-area">
          <div class="toolbar-left" v-if="false">
            <el-dropdown trigger="click" class="batch-action-dropdown" placement="bottom">
              <el-button type="primary"  class="btn dropdown-toggle btn-primary">
                {{ $t('lbl_EMPBE_BatchAction') }}
              </el-button>
              <el-dropdown-menu slot="dropdown"> 
                <el-dropdown-item @click.native="submitReminder()">{{ $t('lbl_EMPBE_CompanyApproval_SendEmail') }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="toolbar-right">
            <el-input
              v-model="searchWord"
              :placeholder="$t('lbl_EMPBE_SearchWord_CompName')"
              class="search-input"
              clearable
              @keyup.enter.native="onFilter"
            />
            <el-button type="primary" class="btn btn-primary search-btn" @click="onFilter">
              {{ $t('lbl_EMPBE_Search') }}
            </el-button>
          </div>
        </div>

        <!-- Hint text -->
        <!-- <div class="hint-text">
          {{ $t('lbl_EMPBE_ColumnHint') }}
        </div> -->

        <!-- Main Table -->
        <el-table
          :data="gridData"
          v-loading="loader"
          border
          stripe
          class="approval-table"
          :header-cell-style="{ background: '#fafafa', color: '#424242', fontWeight: 'normal', fontSize: '14px' }"
          :cell-style="{ padding: '12px' }"
          @filter-change="handleFilterChange"
          @selection-change="handleSelectionChange"
        >
          <!-- Checkbox -->
          <!-- <el-table-column type="selection" width="40" align="center" header-align="center" /> -->

          <!-- Company Name + Action -->
          <el-table-column :label="$t('Lbl_CompanyName')" fixed min-width="200">
            <template slot-scope="scope">
              <div class="company-name-cell">
                <div v-if="scope.row.companyNameSc" class="text-cn" >{{ (scope.row.testAccount?`[TESTING] - `:``)+scope.row.companyNameSc }}</div>
                <div v-if="scope.row.companyNameEn&&scope.row.companyNameSc!=scope.row.companyNameEn" class="text-en">{{(scope.row.testAccount?`[TESTING] - `:``)+scope.row.companyNameEn }}</div>
               <!-- <el-dropdown trigger="click" class="action-dropdown-inline" placement="bottom" >
                  <el-button type="primary"  class="btn dropdown-toggle btn-primary">
                    {{ $t('lbl_EMPBE_Action') }} 
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="openSidebar(scope.row)">
                      {{ $t('lbl_EMPBE_OpenApprovalMode') }}
                    </el-dropdown-item>
                     <li role="presentation"><hr role="separator" aria-orientation="horizontal" class="dropdown-divider"></li>
                    <el-dropdown-item   @click.native="submitReminder(scope.row)">
                      {{ $t('lbl_EMPBE_CompanyApproval_SendEmail') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
                <!-- <button v-if="(scope.row.compInfoStatus&&scope.row.compInfoStatus!='N')
                ||(scope.row.brStatus&&scope.row.brStatus!='N')
                ||(scope.row.prodInfoStatus&&scope.row.prodInfoStatus!='N')
                ||(scope.row.pigStatus&&scope.row.pigStatus!='N')"  
                @click="openSidebar(scope.row)" class="btn btn-primary" style="padding:0.375rem">{{ $t('lbl_EMPBE_OpenApprovalMode') }}</button> -->
                <button @click="openSidebar(scope.row)" class="btn btn-primary" style="padding:0.375rem">{{ $t('lbl_EMPBE_OpenApprovalMode') }}</button>
              </div>
            </template>
          </el-table-column>

          <!-- EMP_CompanyId -->
          <el-table-column
            label="EMP_CompanyId"
            width="130" 
          >
            <template slot-scope="scope">
              <span class="id-text">{{ scope.row.empCompanyId }}</span>
            </template>
          </el-table-column>

          <!-- BR Status (filterable) -->
          <el-table-column
            :label="$t('lbl_EMPBE_CompanyApproval_BRStatus')"
            label-class-name="br-status-filter-header"
            column-key="brStatus"
            max-width="280" min-width="200"
            sortable
            :filters="statusFilterOptions"
            filter-placement="bottom"
          >
            <template slot-scope="scope">
              <div class="status-cell">
                <div class="status-tags" v-if="scope.row.brStatus" >  
                   <StatusTag 
                    v-for="(item, idx) in scope.row.brStatus.split('|')"
                    :key="idx"
                    :status="item.split(',')[0]"
                    :count="item.split(',')[1]"
                    :status-config="statusConfig"/>

                </div>
                <div class="status-meta" v-if="scope.row.brLastSubmitDate || scope.row.brLastApprovalDate">
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastSubmitDate') }}: {{ formatDateTime(scope.row.brLastSubmitDate)}}</div>
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastApprovalDate') }}: {{ formatDateTime(scope.row.brLastApprovalDate)}}</div> 
                   <div class="meta-line">{{ $t('lbl_EMPBE_ApprovalBy') }}: {{ scope.row.brLastSubmitBy || '-' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- Company Info Status (filterable) -->
          <el-table-column
            :label="$t('lbl_EMPBE_CompanyApproval_CompanyInfoStatus')"
            label-class-name="br-status-filter-header"
            column-key="compInfoStatus"
            max-width="280" min-width="200"
            sortable
            :filters="statusFilterOptions"
            filter-placement="bottom"
          >
            <template slot-scope="scope">
              <div class="status-cell">
                <div class="status-tags"  v-if="scope.row.compInfoStatus"  >
                  <StatusTag   
                    :status="scope.row.compInfoStatus.split(',')[0]"
                    count=""
                    :status-config="statusConfig"
                  />
                </div>
                <div class="status-meta" v-if="scope.row.compInfoLastApprovalDate || scope.row.compInfoLastSubmitDate">
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastSubmitDate') }}: {{ formatDateTime(scope.row.compInfoLastSubmitDate)}}</div>
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastApprovalDate') }}: {{formatDateTime( scope.row.compInfoLastApprovalDate)}}</div>
                  <div class="meta-line">{{ $t('lbl_EMPBE_ApprovalBy') }}: {{ scope.row.compInfoLastSubmitBy || '-' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- Product Info Status (filterable) -->
          <el-table-column
            :label="$t('lbl_EMPBE_ProductInfoStatus')"
            label-class-name="br-status-filter-header"
            column-key="prodInfoStatus"
            max-width="280" min-width="200"
            sortable
            :filters="statusFilterOptions"
            filter-placement="bottom"
          >
            <template slot-scope="scope">
              <div class="status-cell">
                <div class="status-tags" v-if="scope.row.prodInfoStatus">
                  <StatusTag  
                   v-for="(item, idx) in scope.row.prodInfoStatus.split('|')"
                    :key="idx"
                    :status="item.includes(',')?item.split(',')[0]:item"
                    :count="item.includes(',')?item.split(',')[1]:''"
                    :status-config="statusConfig"
                  /> 
                </div>
                <div class="status-meta" v-if="scope.row.prodInfoLastSubmitDate || scope.row.prodInfoLastApprovalDate">
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastSubmitDate') }}: {{ formatDateTime(scope.row.prodInfoLastSubmitDate) }}</div>
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastApprovalDate') }}: {{ formatDateTime(scope.row.prodInfoLastApprovalDate) }}</div>
                  <div class="meta-line">{{ $t('lbl_EMPBE_ApprovalBy') }}: {{ scope.row.prodInfoLastSubmitBy || '-' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- PIG Status (filterable) -->
          <el-table-column
            :label="$t('lbl_EMPBE_PIGStatus')"
            label-class-name="br-status-filter-header"
            column-key="pigStatus"
             max-width="280" min-width="200"
            sortable
            :filters="statusFilterOptions"
            filter-placement="bottom"
          >
            <template slot-scope="scope">
              <div class="status-cell">
                <div class="status-tags" v-if="scope.row.pigStatus">
                  <StatusTag 
                   v-for="(item, idx) in scope.row.pigStatus.split('|')"
                    :key="idx"
                    :status="item.includes(',')?item.split(',')[0]:item"
                    :count="item.includes(',')?item.split(',')[1]:''"
                    :status-config="statusConfig"
                  />
                </div>
                <div class="status-meta" v-if="scope.row.pigLastSubmitDate || scope.row.pigLastApprovalDate">
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastSubmitDate') }}: {{ formatDateTime(scope.row.pigLastSubmitDate)}}</div>
                  <div class="meta-line">{{ $t('lbl_EMPBE_LastApprovalDate') }}: {{ formatDateTime(scope.row.pigLastApprovalDate)}}</div>
                </div>
              </div>
            </template>
          </el-table-column>

        </el-table>

        <!-- Pagination -->
        <div class="pagination-area">
         
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="perPage"
            layout="prev, pager, next, sizes"
            :total="totalRows"
            background
          />
        </div>
      </div>
    </div>

    <!-- Sidebar for detail -->
    <div class="b-sidebar-backdrop bg-dark" style="z-index: 100" v-if="sidebarMenu"
      @click="handleSidebarHide()"></div>
    <b-sidebar
      :title="selectedCompanyName"
      :id="'company-approval-sidebar'"
      :ref="'companySidebar'"
      bg-variant="white"
      right
      :shadow="true"
      v-model="sidebarMenu"
    >
      <supplierDetail
        :supplierId="selectedCompanyId"
        :simulatedSupplier="selectedDataItem"
        :sidebarStrus="sidebarMenu"
        :openTabIndex="sidebarOpenTabIndex"
        :id="'supplier'"
        :ref="'supplier_detail'"
        fromPage="CompanyApproval"
        @approval-finished="onApprovalFinished"
      />
      <div class="d-flex" slot="header" >
        <button type="button" style="border: none; background-color: transparent;align-items: center;justify-content: center;display: flex;"
          @click="handleSidebarHide()">
          <i class="icon-close f-14"></i> 
        </button>
        <div style="font-size: 18px;color: rgba(0, 0, 0, 0.80);align-items: center;padding-left:8px;">{{ $t('lbl_EMPBE_ApprovalMode')}}</div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import supplierDetail from "./supplierDetail/SupplierCompApproval.vue";
import StatusTag from "./StatusTag.vue";
import { adminService } from "../../_services";
import { clearAdminDeepLinkFromRoute } from "../../_helpers/adminDeepLinkRoute";

const STATUS_TYPE_APPROVAL = "APPROVAL"; 

const STATUS_COLOR_BY_CODE = {
  N: { bg: "rgb(233,233,233)", color: "rgb(0,0,0)" ,label:'lbl_EMPBE_NotSubmitted'},
  P: { bg: "rgb(255,208,44)", color: "rgb(0,0,0)" ,label:'lbl_EMPBE_Approval_AIReview'},
  PA: { bg: "rgb(255,208,44)", color: "rgb(0,0,0)" ,label:'lbl_EMPBE_Approval_ManualReview'},
  A: { bg: "rgb(81,187,37)", color: "rgb(255,255,255)"}, //Approved
  R: { bg: "rgb(220,53,69)", color: "rgb(255,255,255)" },  
};

const DEFAULT_STATUS_COLOR = { bg: "rgb(233,233,233)", color: "rgb(0,0,0)" };

function pickNonEmptyName(...values) {
  for (let i = 0; i < values.length; i += 1) {
    const v = values[i];
    if (v != null && String(v).trim() !== '') {
      return String(v).trim();
    }
  }
  return '';
}

export default {
  components: {
    supplierDetail,
    StatusTag,
  },
  data() {
    return {
      searchWord: "",
      loader: false,
      gridData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      sidebarMenu: false,
      selectedDataItem: {},
      selectedDataItems: [],
      selectedAccountId: "0",
      selectedCompanyId: "0",
      statusConfig: {},
      brStatusConfig: {},
      statusFilterOptions: [],
      statusFilters: {
        brStatus: [],
        compInfoStatus: [],
        prodInfoStatus: [],
        pigStatus: [],
      },
      statusTypeApproval: STATUS_TYPE_APPROVAL,
      isFirstLoad: true,
      sidebarOpenTabIndex: 0,
    };
  },
  computed: {
    langid() {
      return localStorage.getItem("currentLangId");
    },
    selectedCompanyName() {
      if (!this.selectedDataItem) return "";
      return this.langid === "1252"
        ? this.selectedDataItem.companyNameEn
        : this.langid === "950"
        ? this.selectedDataItem.companyNameTc
        : this.selectedDataItem.companyNameSc;
    },
    paginationStart() {
      return this.totalRows === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1;
    },
    paginationEnd() {
      return Math.min(this.currentPage * this.perPage, this.totalRows);
    },
  },
  mounted() {
    // URL deep-link：从管理员编辑模式跳转带 companyId
    const companyId = this.$route.query.companyId || this.$route.query.accountid;
    if (companyId) {
      this.searchWord = String(companyId);
      this.sidebarOpenTabIndex = this.resolveOpenTabIndexFromQuery();
    }
    this.loadStatusOptions();
    this.loadData();
  },
  watch: {
    sidebarMenu(val) {
      if (!val) {
        clearAdminDeepLinkFromRoute(this.$router);
      }
    },
    searchWord(val) {
      if ((val || "").trim() !== "") return;
      this.currentPage = 1;
      this.loadData();
    },
  },
  methods: {
    normalizeStatusItem(item) {
      const statusCode = item.statusCode || item.StatusCode || "";
      const defaultText = item.statusText || item.StatusText || statusCode;
      const mappedLabel = STATUS_COLOR_BY_CODE[statusCode]?.label;
      let labelText=this.$t(mappedLabel) ;
      
      const statusText = mappedLabel ? labelText : defaultText; 
      return {
        statusCode,
        statusText
      };
    },
    // Convert backend datetime string/epoch to `yyyy/MM/dd HH:mm:ss`
    formatDateTime(value) {
      if (!value) return "-";

      // If backend sends `YYYY-MM-DD HH:mm:ss`, JS Date() may fail; normalize to ISO.
      let v = typeof value === "string" ? value.trim() : value;
      if (typeof v === "string" && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(v)) {
        v = v.replace(" ", "T");
      }

      const d = v instanceof Date ? v : new Date(v);
      if (!d || isNaN(d.getTime())) return "-";

      const pad = (n) => String(n).padStart(2, "0");
      return (
        d.getFullYear() +
        "/" +
        pad(d.getMonth() + 1) +
        "/" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes())
      );
    },
    buildStatusConfig(statusList,type) {
      const config = {};
      console.log('statusList-type'+type)
      console.log(statusList)
      statusList.forEach((item) => {
        const { statusCode, statusText } = this.normalizeStatusItem(item); 
        if (!statusCode) return;

         config[statusCode] = {
           ...(STATUS_COLOR_BY_CODE[statusCode] || DEFAULT_STATUS_COLOR),
          statusCode,
          statusText,
        };
        if (type === 'br' && statusCode === 'A') {
          config[statusCode].statusText = this.$t('lbl_EMPBE_Effective');
        }
      });
      
      return config;
    },
    
    buildFilterOptions(statusList) {
      return statusList
        .map((item) => this.normalizeStatusItem(item))
        .filter((item) => item.statusText)
        .map((item) => ({ text: item.statusText, value: item.statusCode }));
    },
    loadStatusOptions() {
      adminService.GetAllSysStatusByType(this.statusTypeApproval).then((res) => {
        // res.data 本身就是数组，不要再取 res.data.data
        const approvalList = res?.isSuccessful && Array.isArray(res.data) ? res.data : []; 
        this.statusConfig = this.buildStatusConfig(approvalList);
        //this.brStatusConfig = this.buildStatusConfig(approvalList, 'br');
        this.statusFilterOptions = this.buildFilterOptions(approvalList); 
      });
    },
    loadData() {
      // 侧边栏打开时静默刷新，避免背景表格 el-loading-mask 盖住审批详情
      if (!this.sidebarMenu) {
        this.loader = true;
      }
      const searchText = (this.searchWord || "").trim();
      adminService
        .GetCompanyApprovalList(
          searchText,
          this.currentPage,
          this.perPage,
          this.statusFilters
        )
        .then((res) => {
          const list = res?.companyApprovalModelList;
          this.gridData = Array.isArray(list) ? list : [];
          const total = this.gridData[0]?.totalRows;
          this.totalRows = Number.isFinite(Number(total)) ? Number(total) : this.gridData.length;
          this.syncSelectedDataItem();
        })
        .catch((err) => {
          console.error("GetCompanyApprovalList error:", err);
          this.gridData = [];
          this.totalRows = 0;
        })
        .finally(() => {
          this.loader = false;
          if (this.isFirstLoad) {
            this.tryOpenSidebarFromQuery();
            this.isFirstLoad = false;
          }
        });
    },
    resolveOpenTabIndexFromQuery() {
      const key = String(this.$route.query.tab || this.$route.query.type || "").toLowerCase();
      const tabMap = {
        home: 0,
        company: 1,
        comp: 1,
        product: 2,
        prod: 2,
        pig: 3,
        br: 4,
      };
      if (key && tabMap[key] !== undefined) {
        return tabMap[key];
      }
      if (this.$route.query.productId || this.$route.query.catalogId) {
        return 2;
      }
      return 0;
    },
    tryOpenSidebarFromQuery() {
      const companyId = this.$route.query.companyId || this.$route.query.accountid;
      if (!companyId) return;
      const idStr = String(companyId);
      const match = (this.gridData || []).find(
        (row) =>
          String(row.accountId) === idStr ||
          String(row.empCompanyId) === idStr
      );
      if (match) {
        this.sidebarOpenTabIndex = this.resolveOpenTabIndexFromQuery();
        this.openSidebar(match, true);
      } else if (idStr) {
        // 列表未命中时仍打开侧栏（仅带 accountId），便于继续审批
        this.sidebarOpenTabIndex = this.resolveOpenTabIndexFromQuery();
        this.openSidebar({ accountId: idStr }, true);
      }
    },
    onApprovalFinished() {
      this.loadData();
    },
    syncSelectedDataItem() {
      if (!this.sidebarMenu || !this.selectedCompanyId) return;
      const idStr = String(this.selectedCompanyId);
      const match = (this.gridData || []).find(
        (row) =>
          String(row.empCompanyId) === idStr ||
          String(row.accountId) === idStr
      );
      if (match) {
        this.selectedDataItem = this.normalizeApprovalRow(match);
      }
    },
    onFilter() {
      this.currentPage = 1;
      this.loadData();
    },
    handleFilterChange(filters) {
      console.log('filters')
      console.log(filters)
      Object.keys(filters).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(this.statusFilters, key)) {
          this.statusFilters[key] = Array.isArray(filters[key]) ? filters[key] : [];
        }
      });
      this.currentPage = 1;
      this.loadData();
    },
    handleSizeChange(val) {
      this.perPage = val;
      this.currentPage = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadData();
    },
    handleSelectionChange(selection) {
      this.selectedDataItems = selection || [];
    },
    showAlert(message) {
      this.$swal({
        html: message,
        htmlMode: true,
        showConfirmButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
      });
    },
    submitReminder(dataItem) {
      // Single row: pass dataItem; batch: use table checkbox selection
      var selectedItems = dataItem
        ? [dataItem]
        : this.selectedDataItems;

      if (!selectedItems || selectedItems.length < 1) {
        this.showAlert(this.$t("Lbl_Popupform_Error"));
      } else {
        this.$swal({
          text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
          showCancelButton: true,
          type: "confirm",
          showConfirmButton: true,
          confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
          cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
        }).then((result) => {
          if (result.value) {
            var list = selectedItems.map((item) => ({
              accountId: item.accountId,
              langId: this.langid,
            }));
            var currentUser = this.$store.state.authentication.user;
            var currentLogin = "SYSTEM";
            if (currentUser != null) {
              currentLogin = currentUser.login;
            }

            var paramList = {
              DetailList: list,
              action: {
                LangId: localStorage.getItem("currentLangId"),
                IP: window.location.host,
                URL: window.location.href,
                Referral: document.referrer,
                BAgent: window.navigator.userAgent,
                Action: "SendReminderEmailAll",
                ActionBy: currentLogin,
              },
            };

            adminService.SubmitReminderEmail(paramList).then((res) => {
              var msg = "";
              if (!res.isSuccessful) {
                msg = res.systemErrorMsg.join("<br>");
              } else {
                msg = this.$t("lbl_EMPBE_SubmitReminderEmailSuccess");
              }
              this.showAlert(msg);
            });
          }
        });
      }
    },
    openSidebar(dataItem, fromQuery) {
      if (dataItem) {
        this.selectedDataItem = this.normalizeApprovalRow(dataItem);
        this.selectedAccountId = String(this.selectedDataItem.accountId || '');
        this.selectedCompanyId = String(this.selectedDataItem.empCompanyId || '');
        this.sidebarMenu = true;
      }
    },
    /** 审批列表行 → simulatedSupplier（补全 camelCase / 繁体名回退） */
    normalizeApprovalRow(row) {
      if (!row) return {};
      const sc = pickNonEmptyName(row.companyNameSc, row.CompanyNameSc);
      const en = pickNonEmptyName(row.companyNameEn, row.CompanyNameEn);
      const tc = pickNonEmptyName(row.companyNameTc, row.CompanyNameTc, sc);
      return {
        ...row,
        accountId: row.accountId ?? row.AccountId,
        empCompanyId: row.empCompanyId ?? row.EMPCompanyId ?? row.EmpCompanyId,
        companyNameSc: sc,
        companyNameEn: en,
        companyNameTc: tc,
        compinfoStatus: row.compinfoStatus ?? row.compInfoStatus ?? row.CompInfoStatus ?? '',
        prodInfoStatus: row.prodInfoStatus ?? row.prodInfoStatus ?? row.ProdInfoStatus ?? '',
        pigStatus: row.pigStatus ?? row.PIGStatus ?? '',
        brStatus: row.brStatus ?? row.BRStatus ?? '',
      };
    },
    handleSidebarHide() {
      if (this.$store.state.dirty) {
        this.showLeavePage().then((result) => {
          if (result.isConfirmed) {
            this.$refs["companySidebar"]?.hide?.();
            this.$store.state.dirty = false;
          }
        });
      } else {
        //this.loadData() ;
        this.$refs["companySidebar"]?.hide?.();
      }
    },
    showLeavePage() {
      return this.$swal({
        text: this.$t("Lbl_LeavePageConfirm"),
        showCancelButton: true,
        type: "confirm",
        showConfirmButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      });
    },
  },
};
</script>

<style scoped>
.card-radius {
  border-radius: 24px;
}

/* Toolbar */
.toolbar-area {
  display: flex;
 
  align-items: center;
  padding: 12px 16px;
  background-color: #fafafa;
  border-radius: 8px 8px 0 0;
  gap: 8px;
}

.toolbar-left {
  display: flex;
  align-items: center;
}

.toolbar-right {
  display: flex;
  align-items: center;
}

.search-input {
  width: 360px;
}

.search-input ::v-deep .el-input__inner {
  border-radius: 4px;
  height: 38px;
  font-size: 16px;
}

.search-btn { 
  min-width: 111px;  
}

.el-button {
     padding: 9px 20px;
     font-weight: 600; 
}

/* Hint text */
.hint-text {
  padding: 10px 16px;
  font-size: 14px;
  color: #424242;
  background-color: #fafafa;
}

/* Table styles */
.approval-table {
  border-radius: 0;
}

.company-name-cell {
  padding: 8px 0;
}

.text-cn, .text-en {
  font-size: 14px;
  color: #424242;
  word-break: break-all;
}

.text-cn {
  margin-bottom: 4px;
}

.id-text {
  font-size: 14px;
  color: #424242;
}
 

.status-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-bottom: 6px;
}

.status-meta {
  font-size: 12px;
  color: #6c757d;
}
 
/* Inline action button */
.action-dropdown-inline {
  margin-top: 8px;
}

 

/* Pagination */
.pagination-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #fafafa;
  border-radius: 0 0 8px 8px;
}

.pagination-info {
  font-size: 14px;
  color: #424242;
}

::v-deep .el-table th { 
  height: 37px; 
    padding: 0 2px 0 12px;
}

::v-deep .el-table__body td {
  padding: 20px 12px !important;
}

/* Stripe rows: override Element UI default stripe color */
::v-deep .approval-table.el-table--striped .el-table__body tr.el-table__row--striped > td.el-table__cell {
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.03) 0%, rgba(0, 0, 0, 0.03) 100%), #fff;
}

::v-deep .el-table .cell {
  word-break: break-word;
    padding:0px;
}

::v-deep .el-table--border th:first-child .cell,
::v-deep .el-table--border td:first-child .cell {
  padding-left: 0px;
}

::v-deep .el-table .el-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* First column: checked checkbox uses red */
::v-deep .approval-table th:first-child .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .approval-table td:first-child .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .approval-table th:first-child .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color:var(--theme-deafult, #7366ff);
  border-color: var(--theme-deafult, #7366ff);
}

::v-deep .approval-table th:first-child .el-checkbox__input.is-focus .el-checkbox__inner,
::v-deep .approval-table td:first-child .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--theme-deafult, #7366ff);
}

/* Filter columns: only icon opens dropdown (not whole header click) */
::v-deep .br-status-filter-header {
  cursor: default;
}

::v-deep .br-status-filter-header .caret-wrapper {
  display: none !important;
}

/* BR Status column: use Kendo column menu icon (k-icon k-i-more-vertical) */
::v-deep .br-status-filter-header .el-table__column-filter-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: calc(1.4285714286em + 10px);
  height: calc(1.4285714286em + 10px);
  padding: 4px;
  box-sizing: border-box;
  line-height: 1.4285714286;
  cursor: pointer;
}

::v-deep .br-status-filter-header .el-table__column-filter-trigger i {
  font-family: "WebComponentsIcons" !important;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  speak: none;
  color: #424242;
  transform: none;
}

::v-deep .br-status-filter-header .el-table__column-filter-trigger i::before {
  content: "\e031";
}

::v-deep .br-status-filter-header .el-table__column-filter-trigger:hover {
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}

::v-deep .br-status-filter-header.highlight .el-table__column-filter-trigger i {
  color: var(--theme-deafult, #7366ff);
}
::v-deep .el-table th.el-table__cell>.cell{
      display: flex;
      padding:0px;
    justify-content: space-between;
    align-items: center;
}
::v-deep label{
      margin-bottom: 0rem;
}

 
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{ 
      color: var(--theme-deafult, #7366ff);
      background-color: rgba(115, 102, 255, 0.20);
}
::v-deep .dropdown-menu {
    
    border: 1px solid rgba(0, 0, 0, 0.15);
    padding:8p 0;
}
::v-deep .el-dropdown-menu__item,::v-deep .el-menu-item{ 
  height:29px;
  color: #212529;
  font-size: 14px;
  align-items: center;
  justify-content: left;
display: flex;
}
::v-deep .el-dropdown-menu__item:focus,::v-deep .el-dropdown-menu__item:not(.is-disabled):hover{ 
  background-color: #e9ecef !important;
    color: #212529 !important;
}

</style>
<style>
.el-table-filter__wrap{
     max-height: unset;
}
#company-approval-sidebar.b-sidebar {
    min-width: 800px !important;
    width: 95% !important;
}
#company-approval-sidebar .PublicTabs .tab-left-Big{
    width: 24%;
}
#company-approval-sidebar .PublicTabs .tab-center-Big{
 width: 72% 
}
#company-approval-sidebar #companyInfoForm .tab-left-tab,
#company-approval-sidebar #productInfoForm .tab-left-tab{
    flex: 0 0 calc((100% - 24px) * 0.25) !important;
    max-width: calc((100% - 24px) * 0.25) !important;
    width: auto !important;
}
#company-approval-sidebar #companyInfoForm .tab-center-tab,
#company-approval-sidebar #productInfoForm .tab-center-tab{
    flex: 1 1 0 !important;
    max-width: none !important;
    width: auto !important;
}
</style>
